import { render } from "./IndexProjet.vue?vue&type=template&id=49019527"
import script from "./IndexProjet.vue?vue&type=script&lang=js"
export * from "./IndexProjet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__